<template>
    <form class="container-fluid m-0 p-0" @submit.prevent="confirmUpdateUser">
        <div class="row bg-light text-left border-top border-bottom py-2 ml-1">
            <div class="col-sm-12 h-100 my-auto p-0 m-0">
                <span class="mx-3 font-weight-bold lead">User Details</span>

                <span class="float-right py-1 mx-2 pr-4">
                    <button type="submit"
                        class="btn btn-xs btn-warning px-2 mr-1"

                    >
                        <span class="fas fa-user-edit"></span>
                        {{  editable ? 'Update' : 'Edit' }}
                    </button>

                    <button type="submit"
                            class="btn btn-xs btn-outline-danger px-2 mr-1"
                            title="Cancel Edit"
                            v-if="editable"
                            @click="cancelEdit"
                    >
                        <span class="fas fa-ban"></span>
                    </button>

                    <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                            @click="goBack"
                    >
                        <span class="fas fa-backward"></span>
                        Go Back
                    </button>
                </span>
            </div>
        </div>

        <div class="row text-small m-3">
            <div class="col col-md-6">
                <div class="form-group form-row mb-1" :class="{ 'has-error': updateUserErrors.last_name }">
                    <label class="col col-sm-2 font-weight-bolder col-form-label text-left form-label-xs pt-3 offset-1"
                           for="lastName">
                        Last Name:
                    </label>
                    <div class="col col-sm-6">
                        <input type="text" id="lastName" required
                               class="form-control form-control-xs"
                               :class="{ 'form-display-edit' : !editable }"
                               :readonly="!editable"
                               v-model="userData.last_name"
                        >
                        <span class="help-block text-danger" v-if="updateUserErrors.last_name">
                            <small><strong>{{ updateUserErrors.last_name }} </strong></small>
                        </span>
                    </div>
                </div>
                <div class="form-group form-row mb-1" :class="{ 'has-error': updateUserErrors.name }">
                    <label class="col col-sm-2 font-weight-bolder col-form-label text-left form-label-xs pt-3 offset-1"
                           for="firstName">
                        First Name:
                    </label>
                    <div class="col col-sm-6">
                        <input type="text" id="firstName" required
                               class="form-control form-control-xs"
                               :class="{ 'form-display-edit' : !editable }"
                               :readonly="!editable"
                               v-model="userData.name"
                        >
                        <span class="help-block text-danger" v-if="updateUserErrors.name">
                            <small><strong>{{ updateUserErrors.name }} </strong></small>
                        </span>
                    </div>
                </div>
                <div class="form-group form-row mb-1" :class="{ 'has-error': updateUserErrors.middle_name }">
                    <label class="col col-sm-2 font-weight-bolder col-form-label text-left form-label-xs pt-3 offset-1"
                           for="middleName">
                        Middle Name:
                    </label>
                    <div class="col col-sm-6">
                        <input type="text" id="middleName"
                               class="form-control form-control-xs"
                               :class="{ 'form-display-edit' : !editable }"
                               :readonly="!editable"
                               v-model="userData.middle_name"
                        >
                        <span class="help-block text-danger" v-if="updateUserErrors.middle_name">
                            <small><strong>{{ updateUserErrors.middle_name }} </strong></small>
                        </span>
                    </div>
                </div>
                <div class="form-group form-row mb-1" :class="{ 'has-error': updateUserErrors.contact }">
                    <label class="col col-sm-2 font-weight-bolder col-form-label text-left form-label-xs pt-3 offset-1"
                           for="contact">
                        Contact:
                    </label>
                    <div class="col col-sm-6">
                        <input type="text" id="contact"
                               class="form-control form-control-xs"
                               :class="{ 'form-display-edit' : !editable }"
                               :readonly="!editable"
                               v-model="userData.contact"
                        >
                        <span class="help-block text-danger" v-if="updateUserErrors.contact">
                            <small><strong>{{ updateUserErrors.contact }} </strong></small>
                        </span>
                    </div>
                </div>
                <div class="form-group form-row mb-1" :class="{ 'has-error': updateUserErrors.email }">
                    <label class="col col-sm-2 font-weight-bolder col-form-label text-left form-label-xs pt-3 offset-1"
                           for="email">
                        Email:
                    </label>
                    <div class="col col-sm-6">
                        <input type="email" id="email"
                               class="form-control form-control-xs"
                               :class="{ 'form-display-edit' : !editable }"
                               :readonly="!editable"
                               v-model="userData.email"
                        >
                        <span class="help-block text-danger" v-if="updateUserErrors.email">
                            <small><strong>{{ updateUserErrors.email }} </strong></small>
                        </span>
                    </div>
                </div>

            </div>
            <div class="col col-md-6">
                <div class="form-group form-row mb-1">
                    <label class="col col-sm-3 font-weight-bolder col-form-label text-left form-label-xs pt-3"
                           for="employeeId">
                        Employee ID:
                    </label>
                    <input type="text" id="employeeId" readonly
                           class="col col-sm-6 form-control form-control-xs form-display-edit"
                           v-model="userData.employee_id"
                    >
                </div>

                <div class="form-group form-row mb-1" :class="{ 'has-error': updateUserErrors.username }">
                    <label class="col col-sm-3 font-weight-bolder col-form-label text-left form-label-xs pt-3"
                           for="username">
                        Username:
                    </label>
                    <div class="col col-sm-6">
                        <input type="text" id="username" required
                               class="form-control form-control-xs"
                               :class="{ 'form-display-edit' : !editable }"
                               :readonly="!editable"
                               v-model="userData.username"
                        >
                        <span class="help-block text-danger" v-if="updateUserErrors.username">
                            <small><strong>{{ updateUserErrors.username }} </strong></small>
                        </span>
                    </div>
                </div>

                <div class="form-group form-row mb-1"
                     :class="{ 'has-error': updateUserErrors.password }"
                     v-if="editable"
                >
                    <label class="col col-sm-3 font-weight-bolder col-form-label text-left form-label-xs pt-3"
                           for="password">
                        Password:
                    </label>
                    <div class="col col-sm-6">
                        <div class="input-group" >
                            <input type="password" id="password"
                                   class="form-control form-control-xs"
                                   v-model="userData.password"
                            >
                            <div class="input-group-append">
                                <button class="btn btn-sm btn-xs" type="button" title="Show Password" @click="showPassword('password')">
                                    <i class="fa fa-eye-slash" aria-hidden="true" id="passwordIcon"></i>
                                </button>
                            </div>
                        </div>
                        <span class="help-block text-danger" v-if="updateUserErrors.password">
                            <small><strong>{{ updateUserErrors.password }} </strong></small>
                        </span>
                    </div>
                </div>

                <div class="form-group form-row mb-1"
                     :class="{ 'has-error': updateUserErrors.confirmPassword }"
                     v-if="editable"
                >
                    <label class="col col-sm-3 font-weight-bolder col-form-label text-left form-label-xs pt-3"
                           for="confirmPassword">
                        Confirm Password:
                    </label>
                    <div class="col col-sm-6">
                        <div class="input-group">
                            <input type="password" id="confirmPassword"
                                   class="form-control form-control-xs"
                                   v-model="userData.confirmPassword"
                            >
                            <div class="input-group-append">
                                <button class="btn btn-sm btn-xs" type="button" title="Show Password" @click="showPassword('confirmPassword')">
                                    <i class="fa fa-eye-slash" aria-hidden="true" id="confirmPasswordIcon"></i>
                                </button>
                            </div>
                        </div>
                        <span class="help-block text-danger" v-if="updateUserErrors.confirmPassword">
                            <small><strong>{{ updateUserErrors.confirmPassword }} </strong></small>
                        </span>
                    </div>
                </div>

                <div class="form-group form-row mb-1" :class="{ 'has-error': updateUserErrors.manning_id }"
                     v-if="userData.manning_id || editable"
                >
                    <label class="col col-sm-3 font-weight-bolder col-form-label text-left form-label-xs pt-3"
                           for="manning">
                        Manning:
                    </label>
                    <div class="col col-sm-6">
                        <select id="manning"
                                v-if="editable"
                                class="form-control form-control-xs"
                                v-model="userData.manning_id"
                        >
                            <option :value="null">-- SELECT MANNING --</option>
                            <option :value="manningKey.id" v-for="manningKey in manningKeys" :key="manningKey.id">
                                {{ manningKey.alias }}
                            </option>
                        </select>
                        <input type="text" id="manning" readonly
                               v-else
                               class="form-control form-control-xs form-display-edit"
                               :value="userData.manning ? userData.manning.alias : '' "
                        >
                        <span class="help-block text-danger" v-if="updateUserErrors.manning_id">
                            <small><strong>{{ updateUserErrors.manning_id }} </strong></small>
                        </span>
                    </div>
                </div>

                <div class="form-group form-row mb-1" :class="{ 'has-error': updateUserErrors.company_id }"
                     v-if="userData.company_id || editable"
                >
                    <label class="col col-sm-3 font-weight-bolder col-form-label text-left form-label-xs pt-3"
                           for="company">
                        Company:
                    </label>
                    <div class="col col-sm-6">
                        <select id="company"
                                v-if="editable"
                                class="form-control form-control-xs"
                                v-model="userData.company_id"
                        >
                            <option :value="null">-- SELECT COMPANY --</option>
                            <option :value="companyKey.id" v-for="companyKey in companyKeys" :key="companyKey.id">
                                {{ companyKey.name }}
                            </option>
                        </select>
                        <input type="text" id="company" readonly
                               v-else
                               class="form-control form-control-xs form-display-edit"
                               :value="userData.company ? userData.company.name : '' "
                        >
                        <span class="help-block text-danger" v-if="updateUserErrors.company_id">
                            <small><strong>{{ updateUserErrors.company_id }} </strong></small>
                        </span>
                    </div>
                </div>

                <div class="form-group form-row mb-1" :class="{ 'has-error': updateUserErrors.active }">
                    <label class="col col-sm-3 font-weight-bolder col-form-label text-left form-label-xs pt-3"
                           for="userStatus">
                        Status:
                    </label>
                    <div class="col col-sm-6">
                        <select id="userStatus" required
                                v-if="editable"
                                class="form-control form-control-xs"
                                v-model="userData.active"
                        >
                            <option :value="1">ACTIVE</option>
                            <option :value="0">INACTIVE</option>
                        </select>
                        <input type="text" id="userStatus" readonly
                               v-else
                               class="form-control form-control-xs form-display-edit"
                               :value="userData.active | status"
                        >
                        <span class="help-block text-danger" v-if="updateUserErrors.active">
                            <small><strong>{{ updateUserErrors.active }} </strong></small>
                        </span>
                    </div>
                </div>

            </div>
        </div>

        <div class="row text-small m-3">
            <div class="col-md-3 offset-1">
                <h5>System Restrictions</h5>
                <div class="form-group row">

                    <div class="col-sm-9 offset-3 text-left mb-2" v-for="systemKey in systemKeys" :key="systemKey.id">
                        <div class="form-check d-block">
                            <input class="form-check-input" type="checkbox"
                                   :value="systemKey.id"
                                   :id="'systemKey' + systemKey.id"
                                   :disabled="!editable"
                                   v-model="systemIds"
                            >
                            <label class="form-check-label w-100"
                                   :for="'systemKey' + systemKey.id"
                                   :class="{
                                       'font-weight-bolder text-success' : systemIds.some(systemId => systemId == systemKey.id),
                                       'text-secondary' : !systemIds.some(systemId => systemId == systemKey.id),
                                   }"
                            >
                                {{ systemKey.name }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-4 offset-1">
                <h5>POSITIONS / ROLES</h5>
                <div class="form-group row">

                    <div class="col-sm-9 offset-3 text-left mb-2" v-for="positionKey in positionKeys" :key="positionKey.id">
                        <div class="form-check d-block">
                            <input class="form-check-input" type="checkbox"
                                   :value="positionKey.id"
                                   :id="'positionKey' + positionKey.id"
                                   :disabled="!editable"
                                   v-model="positionIds"
                            >
                            <label class="form-check-label w-100"
                                   :for="'positionKey' + positionKey.id"
                                   :class="{
                                       'font-weight-bolder text-success' : positionIds.some(positionId => positionId == positionKey.id),
                                       'text-secondary' : !positionIds.some(positionId => positionId == positionKey.id),
                                   }"
                            >
                                {{ positionKey.name }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </form>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { formMixin } from "@/mixins/formMixin";

export default {
    name: "UserShow",
    mixins: [ vueAppMixin ],
    data() {
        return {
            editable: false,
            tempUser: {},
            updateUserErrors: {
                password: '',
                confirmPassword: '',
                manning_id: '',
                company_id: ''
            },
            systemIds: [],
            positionIds: []
        }
    },

    methods: {
        ...mapActions([
            'getUser',
            'refreshUserData',
            'getManningKeys',
            'updateUser',
            'getSystemKeys',
            'getPositionKeys',
            'getCompanyKeys'
        ]),
        async confirmUpdateUser() {

            if(this.editable) {

                if(this.userData.company_id == null && this.userData.manning_id == null) {
                    this.errorAlert('Please Select Either Manning or Company', 'FORM SUBMISSION');
                    this.updateUserErrors.manning_id = 'Please Select Manning'
                    this.updateUserErrors.company_id = 'or Please Select Company'
                    return false;
                }

                if(await this.confirmUpdate()) {
                    if((this.userData.password || this.userData.confirmPassword) && !this.verifyPassword()) {
                        this.errorAlert('Password Not Matched', 'PASSWORD ERROR')
                        return false;
                    }
                    let updateUserDetails = {
                        userId: this.userData.id,
                        last_name: this.userData.last_name,
                        name: this.userData.name,
                        middle_name: this.userData.middle_name,
                        contact: this.userData.contact,
                        email: this.userData.email,
                        username: this.userData.username,
                        manning_id: this.userData.manning_id,
                        company_id: this.userData.company_id,
                        active: this.userData.active,
                        systems: this.systemIds,
                        positions: this.positionIds,
                    };
                    if(this.userData.password) {
                        updateUserDetails['password'] = this.userData.password;
                    }
                    let updatedUser = await this.updateUser(updateUserDetails);
                    if(updatedUser.errors) {
                        this.updateUserErrors = updatedUser.errors;
                    } else {
                        this.successAlert('User Successfully Updated', 'UPDATE');
                        this.updateUserErrors = {};
                        this.editable = false;
                    }
                }
            } else {
                this.editable = true;
                // this.userData = Object.assign({}, this.tempUser);
            }
        },

        verifyPassword() {
            let verified = this.userData.password === this.userData.confirmPassword;
            if(!verified) {
                this.updateUserErrors['confirmPassword'] = 'Password Not Matched';
                this.updateUserErrors['password'] = 'Password Not Matched';
            }
            return verified;
        },

        cancelEdit() {
            this.refreshUserData(Object.assign({}, this.tempUser));
            this.tempUser.systems.forEach(system => this.systemIds.push(system.id));
            this.editable = false;
        },

        showPassword(passwordId) {
            const passInput = document.getElementById(passwordId);
            const x = document.getElementById(passwordId + 'Icon');
            if (passInput.type === 'password') {
                passInput.type = 'text';
                x.setAttribute('class', 'fa fa-eye');
            } else {
                passInput.type = 'password';
                x.setAttribute('class', 'fa fa-eye-slash');
            }
        },

        async initializeData() {
            await this.getManningKeys();
            await this.getCompanyKeys();
            await this.getSystemKeys();
            await this.getPositionKeys();
            await this.getUser(this.$route.params.id);
            this.tempUser = Object.assign({}, this.userData);
            this.userData.systems.forEach(system => this.systemIds.push(system.id));
            this.userData.positions.forEach(position => this.positionIds.push(position.id));
        }
    },

    computed: {
        ...mapGetters([ 'userData', 'manningKeys', 'systemKeys', 'positionKeys', 'companyKeys' ])
    },

    created() {
        this.initializeData();
    }


}
</script>

<style scoped>

</style>
